import { useEffect, useState } from 'react';
import {
  Users,
  Search,
  Plus,
  Download,
  Pencil,
  Trash2,
  MoreVertical,
  GraduationCap,
  BookOpen,
  DollarSign,
  TrendingUp,
  ArrowLeft,
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { host } from '../../api/ApiCalls';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.vfs;

const iconMap = {
  Users,
  DollarSign,
  BookOpen,
  GraduationCap,
  // aur icons yahan add karte jao
};

function StatCard({ title, value, change, icon: Icon, trend }) {
  console.log('StatCard props:', { title, value, change, Icon, trend });
  return (
    <div className="rounded-xl border bg-white shadow-md p-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-800">{title}</h3>
        <Icon className="h-5 w-5 text-indigo-500" />
      </div>
      <div className="mt-2">
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <p
          className={`text-xs ${
            trend === 'up' ? 'text-green-500' : 'text-red-500'
          }`}
        >
          {change}
        </p>
      </div>
    </div>
  );
}

export default function StudentManagement({
  component,
  setComponent,
  students,
  stats,
  setStudents,
}) {
  // const [students, setStudents] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('All Grades');
  const [selectedStatus, setSelectedStatus] = useState('All Status');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingStudent, setEditingStudent] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  const [dateFilter, setDateFilter] = useState('');
  const [downloadOption, setDownloadOption] = useState('');
  // const [stats, setStats] = useState([])

  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   const fetchStudents = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await axios.get("http://localhost:4000/api/admin/allStudents"); // 👈 update with your API URL
  //       setStudents(res.data.students); // data format from controller
  //       setStats(res.data.stats); // data format from controller
  //       setLoading(false);
  //     } catch (err) {
  //       console.error("Error fetching students:", err);
  //       setLoading(false);
  //     }
  //   };

  //   fetchStudents();
  // }, []);

  // Stats data
  // const stats = [
  //   {
  //     title: "Total Students",
  //     value: students.length,
  //     icon: Users,
  //     color: "text-blue-600",
  //   },
  //   {
  //     title: "Total Courses",
  //     value: "156",
  //     icon: BookOpen,
  //     color: "text-green-600",
  //   },

  // ]

  // Handle student deletion
  const handleDeleteStudent = (student) => {
    setStudentToDelete(student);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      const res = await axios.delete(
        `${host}/api/student/${studentToDelete.stdId}`
      );
      if (res.status === 200) {
        setStudents(students.filter((s) => s.id !== studentToDelete.id));
        setShowDeleteConfirm(false);
        setStudentToDelete(null);
        toast.success(`Student ${studentToDelete.name} deleted successfully`);
      }
    } catch (err) {
      console.error('Error deleting student:', err);
      toast.error(`Error deleting student ${studentToDelete.name}`);
    }
  };

  // Handle student form submission
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const formData = new FormData(e.target);
  //   const studentData = {
  //     id: editingStudent ? editingStudent.id : Date.now(),
  //     name: formData.get('name'),
  //     email: formData.get('email'),
  //     grade: formData.get('grade'),
  //     courses: Array.from(formData.getAll('courses')),
  //     status: 'Active',
  //     attendance: '0%',
  //     avgGrade: 'N/A',
  //     lastActive: 'Just now',
  //   };

  //   if (editingStudent) {
  //     setStudents(
  //       students.map((s) => (s.id === editingStudent.id ? studentData : s))
  //     );
  //   } else {
  //     setStudents([...students, studentData]);
  //   }
  //   setIsModalOpen(false);
  //   setEditingStudent(null);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;

    try {
      let res;

      // If editing an existing student
      if (editingStudent) {
        res = await axios.put(`${host}/api/student/${editingStudent.stdId}`, {
          name,
          email,
        });
      } else {
        // If adding new student (you can handle separately)
        res = await axios.post(`${host}/api/admin-dashboard`, {
          name,
          email,
        });
      }

      // Success
      console.log(res.data);
      toast.success(editingStudent ? 'Student updated' : 'Student added');

      // Reset modal
      setIsModalOpen(false);
      setEditingStudent(null);
      form.reset();

      // Optionally, refresh student list
      // fetchStudents(); // You must have a function like this
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    }
  };
  const handleCSVDownload = () => {
    if (!students || students.length === 0) {
      alert('No student data to export.');
      return;
    }

    const headers = Object.keys(students[0]); // Get column names

    const csvRows = [
      headers.join(','), // Header row
      ...students.map((student) =>
        headers
          .map((field) => {
            const value = student[field] ?? ''; // Fallback to empty if undefined/null
            return `"${String(value).replace(/"/g, '""')}"`; // Escape quotes
          })
          .join(',')
      ),
    ];

    const csv = csvRows.join('\n');
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'students.csv';
    a.click();

    URL.revokeObjectURL(url); // Clean up
  };
  const downloadStudentsAsPDF = (students) => {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [25, 35, 25, 40],

      // Header section
      header: {
        margin: [25, 15, 25, 0],
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              {
                stack: [
                  { text: 'AcademiaHub', style: 'headerCompany' },
                  {
                    text: 'Educational Management System',
                    style: 'headerSubtitle',
                  },
                ],
                margin: [0, 5, 0, 0],
              },
              {
                stack: [
                  { text: 'STUDENT REPORT', style: 'headerTitle' },
                  {
                    text: `Generated: ${new Date().toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}`,
                    style: 'headerDate',
                  },
                ],
                alignment: 'right',
                margin: [0, 5, 0, 0],
              },
            ],
          ],
        },
        layout: 'noBorders',
      },

      content: [
        // Summary section
        {
          margin: [0, 20, 0, 15],
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'Total Students', style: 'summaryLabel' },
                { text: 'Active Enrollments', style: 'summaryLabel' },
                { text: 'Total Courses', style: 'summaryLabel' },
                { text: 'Average Courses', style: 'summaryLabel' },
              ],
              [
                { text: students.length.toString(), style: 'summaryValue' },
                {
                  text: students
                    .filter((s) => s.courses && s.courses.length > 0)
                    .length.toString(),
                  style: 'summaryValue',
                },
                {
                  text: students
                    .reduce((acc, s) => acc + (s.totalCourses || 0), 0)
                    .toString(),
                  style: 'summaryValue',
                },
                {
                  text:
                    students.length > 0
                      ? (
                          students.reduce(
                            (acc, s) => acc + (s.totalCourses || 0),
                            0
                          ) / students.length
                        ).toFixed(1)
                      : '0',
                  style: 'summaryValue',
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#34495e' : '#ecf0f1'),
            textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6,
          },
        },

        { text: '\n' },

        // Main data table
        {
          table: {
            headerRows: 1,
            widths: [30, 140, 90, 70, 50, 60, '*'],
            body: [
              [
                { text: 'ID', style: 'tableHeader' },
                { text: 'Student Information', style: 'tableHeader' },
                { text: 'Username', style: 'tableHeader' },
                { text: 'Join Date', style: 'tableHeader' },
                { text: 'Status', style: 'tableHeader' },
                { text: 'Enrollment/Courses', style: 'tableHeader' },
                { text: 'Course Assignments', style: 'tableHeader' },
              ],
              ...students.map((student, index) => [
                {
                  text: String(index + 1).padStart(3, '0'),
                  style: 'cellData',
                  alignment: 'center',
                  fillColor: '#f8f9fa',
                },
                {
                  stack: [
                    { text: student.name || 'Unknown', style: 'studentName' },
                    {
                      text: student.email || 'No email',
                      style: 'studentEmail',
                    },
                  ],
                  margin: [4, 3, 4, 3],
                },
                {
                  text: student.username || 'N/A',
                  style: 'cellData',
                  alignment: 'left',
                },
                {
                  stack: [
                    { text: student.dateJoined || 'N/A', style: 'dateText' },
                    { text: student.timeJoined || '', style: 'timeText' },
                  ],
                  alignment: 'center',
                },
                {
                  text:
                    student.courses && student.courses.length > 0
                      ? 'Active'
                      : 'Inactive',
                  style:
                    student.courses && student.courses.length > 0
                      ? 'statusActive'
                      : 'statusInactive',
                  alignment: 'center',
                  margin: [2, 4, 2, 4],
                },
                {
                  stack: [
                    {
                      text: `Enrolled: ${
                        student.courses ? student.courses.length : 0
                      }`,
                      style: 'statsText',
                    },
                    {
                      text: `Total: ${student.totalCourses || 0}`,
                      style: 'statsText',
                    },
                  ],
                  alignment: 'center',
                  fillColor: '#e8f4fd',
                  margin: [2, 2, 2, 2],
                },
                {
                  text:
                    student.courses && student.courses.length > 0
                      ? student.courses
                          .map((course) => `• ${course}`)
                          .join('\n')
                      : 'No active enrollments',
                  style:
                    student.courses && student.courses.length > 0
                      ? 'courseList'
                      : 'noCourses',
                  margin: [4, 2, 4, 2],
                },
              ]),
            ],
          },
          layout: {
            fillColor: (rowIndex, node) => {
              if (rowIndex === 0) return '#2c3e50';
              return rowIndex % 2 === 0 ? '#fdfdfd' : null;
            },
            textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
            hLineColor: '#bdc3c7',
            vLineColor: '#bdc3c7',
            hLineWidth: (i, node) =>
              i === 0 || i === node.table.body.length ? 1 : 0.5,
            vLineWidth: () => 0.5,
            paddingLeft: () => 4,
            paddingRight: () => 4,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],

      // Footer
      footer: (currentPage, pageCount) => {
        return {
          margin: [25, 10, 25, 0],
          table: {
            widths: ['*', 'auto', '*'],
            body: [
              [
                {
                  text: 'AcademiaHub Educational Management System',
                  style: 'footerLeft',
                },
                {
                  text: `Page ${currentPage} of ${pageCount}`,
                  style: 'footerCenter',
                },
                {
                  text: '© 2025 - Confidential Document',
                  style: 'footerRight',
                },
              ],
            ],
          },
          layout: 'noBorders',
        };
      },

      styles: {
        // Header styles
        headerCompany: {
          fontSize: 18,
          bold: true,
          color: '#2c3e50',
          letterSpacing: 0.5,
        },
        headerSubtitle: {
          fontSize: 9,
          color: '#7f8c8d',
          italics: true,
          margin: [0, 2, 0, 0],
        },
        headerTitle: {
          fontSize: 16,
          bold: true,
          color: '#2c3e50',
          letterSpacing: 1,
        },
        headerDate: {
          fontSize: 8,
          color: '#7f8c8d',
          margin: [0, 3, 0, 0],
        },

        // Summary styles
        summaryLabel: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 2, 0, 2],
        },
        summaryValue: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 2, 0, 2],
        },

        // Table styles
        tableHeader: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 4],
          color: 'white',
        },
        cellData: {
          fontSize: 8,
          margin: [2, 2, 2, 2],
          lineHeight: 1.2,
        },
        studentName: {
          fontSize: 9,
          bold: true,
          color: '#2c3e50',
          margin: [0, 0, 0, 1],
        },
        studentEmail: {
          fontSize: 7,
          color: '#7f8c8d',
          italics: true,
        },
        dateText: {
          fontSize: 8,
          bold: true,
          color: '#2c3e50',
        },
        timeText: {
          fontSize: 7,
          color: '#95a5a6',
          margin: [0, 1, 0, 0],
        },
        statusActive: {
          fontSize: 8,
          bold: true,
          color: '#27ae60',
          fillColor: '#d5f4e6',
          margin: [0, 2, 0, 2],
        },
        statusInactive: {
          fontSize: 8,
          bold: true,
          color: '#e74c3c',
          fillColor: '#fadbd8',
          margin: [0, 2, 0, 2],
        },
        statsText: {
          fontSize: 7,
          color: '#2980b9',
          bold: true,
          margin: [0, 1, 0, 1],
        },
        courseList: {
          fontSize: 7,
          lineHeight: 1.3,
          color: '#34495e',
        },
        noCourses: {
          fontSize: 7,
          italics: true,
          color: '#95a5a6',
          alignment: 'center',
        },

        // Footer styles
        footerLeft: {
          fontSize: 8,
          color: '#7f8c8d',
          alignment: 'left',
        },
        footerCenter: {
          fontSize: 8,
          color: '#2c3e50',
          bold: true,
          alignment: 'center',
        },
        footerRight: {
          fontSize: 8,
          color: '#7f8c8d',
          alignment: 'right',
        },
      },
    };

    // Generate and download the PDF
    pdfMake.createPdf(docDefinition).download('AcademiaHub_Student_Report.pdf');
  };
  // Alternative version with enhanced formatting for large datasets
  const downloadStudentsAsPDFEnhanced = (students) => {
    // Split students into chunks if there are too many
    const studentsPerPage = 25;
    const chunks = [];
    for (let i = 0; i < students.length; i += studentsPerPage) {
      chunks.push(students.slice(i, i + studentsPerPage));
    }

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 30, 20, 35],

      content: [
        // Title page
        {
          stack: [
            {
              text: 'AcademiaHub',
              style: 'titlePage',
              alignment: 'center',
              margin: [0, 50, 0, 10],
            },
            {
              text: 'Student Comprehensive Report',
              style: 'titlePageSub',
              alignment: 'center',
              margin: [0, 0, 0, 20],
            },
            {
              text: `Generated on ${new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}`,
              style: 'titlePageDate',
              alignment: 'center',
              margin: [0, 0, 0, 30],
            },

            // Executive Summary
            {
              text: 'Executive Summary',
              style: 'sectionTitle',
              margin: [0, 20, 0, 10],
            },
            {
              ul: [
                `Total Students Enrolled: ${students.length}`,
                `Active Students: ${
                  students.filter((s) => s.courses && s.courses.length > 0)
                    .length
                }`,
                `Total Course Enrollments: ${students.reduce(
                  (acc, s) => acc + (s.totalCourses || 0),
                  0
                )}`,
                `Average Courses per Student: ${(
                  students.reduce((acc, s) => acc + (s.totalCourses || 0), 0) /
                  students.length
                ).toFixed(2)}`,
              ],
              style: 'summaryList',
            },
          ],
          pageBreak: 'after',
        },

        // Data tables for each chunk
        ...chunks.map((chunk, chunkIndex) => ({
          stack: [
            {
              text: `Student Details - Page ${chunkIndex + 1}`,
              style: 'pageTitle',
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [25, 130, 80, 65, 45, 50, '*'],
                body: [
                  [
                    { text: 'ID', style: 'tableHeaderEnhanced' },
                    { text: 'Student Details', style: 'tableHeaderEnhanced' },
                    { text: 'Username', style: 'tableHeaderEnhanced' },
                    { text: 'Join Date', style: 'tableHeaderEnhanced' },
                    { text: 'Status', style: 'tableHeaderEnhanced' },
                    { text: 'Courses', style: 'tableHeaderEnhanced' },
                    {
                      text: 'Enrollment Details',
                      style: 'tableHeaderEnhanced',
                    },
                  ],
                  ...chunk.map((student, index) => [
                    {
                      text: String(
                        chunkIndex * studentsPerPage + index + 1
                      ).padStart(3, '0'),
                      style: 'cellEnhanced',
                      alignment: 'center',
                      fillColor: '#f1f2f6',
                    },
                    {
                      stack: [
                        {
                          text: student.name || 'Unknown Student',
                          style: 'nameEnhanced',
                        },
                        {
                          text: student.email || 'No email provided',
                          style: 'emailEnhanced',
                        },
                      ],
                      margin: [3, 2, 3, 2],
                    },
                    {
                      text: student.username || 'Not assigned',
                      style: 'cellEnhanced',
                    },
                    {
                      text: student.dateJoined || 'Unknown',
                      style: 'cellEnhanced',
                      alignment: 'center',
                    },
                    {
                      text:
                        student.courses && student.courses.length > 0
                          ? 'ACTIVE'
                          : 'INACTIVE',
                      style:
                        student.courses && student.courses.length > 0
                          ? 'activeStatus'
                          : 'inactiveStatus',
                      alignment: 'center',
                    },
                    {
                      text: (student.totalCourses || 0).toString(),
                      style: 'countEnhanced',
                      alignment: 'center',
                      fillColor: '#dff9fb',
                    },
                    {
                      text:
                        student.courses && student.courses.length > 0
                          ? student.courses.join(' • ')
                          : 'No active enrollments',
                      style:
                        student.courses && student.courses.length > 0
                          ? 'coursesEnhanced'
                          : 'noCoursesEnhanced',
                      margin: [3, 2, 3, 2],
                    },
                  ]),
                ],
              },
              layout: {
                fillColor: (rowIndex) => {
                  if (rowIndex === 0) return '#2f3640';
                  return rowIndex % 2 === 0 ? '#f8f9fa' : null;
                },
                textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
                hLineColor: '#ced6e0',
                vLineColor: '#ced6e0',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                paddingLeft: () => 4,
                paddingRight: () => 4,
                paddingTop: () => 3,
                paddingBottom: () => 3,
              },
            },
          ],
          pageBreak: chunkIndex < chunks.length - 1 ? 'after' : undefined,
        })),
      ],

      footer: (currentPage, pageCount) => ({
        margin: [20, 0, 20, 0],
        table: {
          widths: ['*', 'auto', '*'],
          body: [
            [
              {
                text: 'AcademiaHub © 2025',
                style: 'footerEnhanced',
                alignment: 'left',
              },
              {
                text: `${currentPage} / ${pageCount}`,
                style: 'footerPageEnhanced',
              },
              {
                text: 'Confidential Report',
                style: 'footerEnhanced',
                alignment: 'right',
              },
            ],
          ],
        },
        layout: 'noBorders',
      }),

      styles: {
        titlePage: { fontSize: 24, bold: true, color: '#2c3e50' },
        titlePageSub: { fontSize: 16, color: '#7f8c8d', italics: true },
        titlePageDate: { fontSize: 12, color: '#95a5a6' },
        sectionTitle: { fontSize: 14, bold: true, color: '#2c3e50' },
        summaryList: { fontSize: 11, margin: [20, 5, 0, 5] },
        pageTitle: { fontSize: 14, bold: true, color: '#2c3e50' },
        tableHeaderEnhanced: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 3, 0, 3],
        },
        cellEnhanced: { fontSize: 8, margin: [1, 1, 1, 1] },
        nameEnhanced: { fontSize: 9, bold: true, color: '#2c3e50' },
        emailEnhanced: {
          fontSize: 7,
          color: '#7f8c8d',
          italics: true,
          margin: [0, 1, 0, 0],
        },
        countEnhanced: { fontSize: 10, bold: true, color: '#2980b9' },
        activeStatus: {
          fontSize: 7,
          bold: true,
          color: '#27ae60',
          fillColor: '#d5f4e6',
        },
        inactiveStatus: {
          fontSize: 7,
          bold: true,
          color: '#e74c3c',
          fillColor: '#fadbd8',
        },
        coursesEnhanced: { fontSize: 7, lineHeight: 1.2, color: '#34495e' },
        noCoursesEnhanced: {
          fontSize: 7,
          italics: true,
          color: '#bdc3c7',
          alignment: 'center',
        },
        footerEnhanced: { fontSize: 8, color: '#7f8c8d' },
        footerPageEnhanced: { fontSize: 9, bold: true, color: '#2c3e50' },
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download('AcademiaHub_Enhanced_Student_Report.pdf');
  };
  const handleDownloadChange = (e) => {
    const value = e.target.value;
    setDownloadOption(''); // Reset dropdown after selection

    if (value === 'csv') {
      handleCSVDownload();
    } else if (value === 'pdf') {
      downloadStudentsAsPDF(filteredStudents);
    }
  };

  // Filter students based on search, grade, and status
  const getFilteredDate = (filter) => {
    const now = new Date();
    switch (filter) {
      case 'lastWeek':
        return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      case 'lastMonth':
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return lastMonth;
      case 'last3Months':
        const last3Months = new Date(now);
        last3Months.setMonth(now.getMonth() - 3);
        return last3Months;
      case 'last6Months':
        const last6Months = new Date(now);
        last6Months.setMonth(now.getMonth() - 6);
        return last6Months;
      default:
        return null;
    }
  };
  
  const filteredStudents = students.filter((student) => {
    // Search filter - only by student name
    const matchesSearch = student.name?.toLowerCase().includes(searchQuery.toLowerCase());
  
    // Grade filter
    const matchesGrade =
      selectedGrade === 'All Grades' || student.grade === selectedGrade;
  
    // Status filter
    const matchesStatus =
      selectedStatus === 'All Status' || student.status === selectedStatus;
  
    // If no date filter is applied, return other matches
    if (!dateFilter) {
      return matchesSearch && matchesGrade && matchesStatus;
    }
  
    // Apply date filter if provided - filter by date student joined the app
    const filterDate = getFilteredDate(dateFilter);
    if (!filterDate) {
      return matchesSearch && matchesGrade && matchesStatus;
    }
  
    const studentJoinedDate = new Date(student.dateJoined);
    
    // Handle invalid dates
    if (isNaN(studentJoinedDate.getTime())) {
      return matchesSearch && matchesGrade && matchesStatus;
    }
  
    return (
      matchesSearch &&
      matchesGrade &&
      matchesStatus &&
      studentJoinedDate >= filterDate
    );
  });

  return (
    <div className="space-y-6">
      {/* Stats */}
      <div className="space-y-6 p-6 bg-gray-50 min-h-screen">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
  <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-800 flex items-center">
    <button
      className="p-2 hover:bg-gray-100 rounded mr-2"
      onClick={() => setComponent('AdminDashboard')}
    >
      <ArrowLeft className="h-6 w-6 text-gray-500" />
    </button>
    <Users className="inline-block mr-2" />
    Student Management
  </h2>

  <div className="w-full md:w-auto">
    <select
      onChange={handleDownloadChange}
      value={downloadOption}
      className="w-full md:w-auto bg-indigo-500 text-white font-bold py-2 px-4 rounded cursor-pointer"
    >
      <option value="" disabled className="text-black bg-white border-bottom">
        Select download format
      </option>
      <option value="csv" className="text-black bg-white">
        Download as CSV
      </option>
      <option value="pdf" className="text-black bg-white">
        Download as PDF
      </option>
    </select>
  </div>
</div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 grid-rows-1">
          {stats.map((stat) => (
            <StatCard
              title={stat.title}
              value={stat.value}
              // change="+12.5% from last month"
              icon={iconMap[stat.icon]}
              // trend="up"
            />
          ))}
        </div>

        {/* Search and Filters */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex w-full items-center justify-between gap-4">
            {/* Search Input */}
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search students..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Date Filter */}
            <select
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Time</option>
              <option value="lastWeek">Last Week</option>
              <option value="lastMonth">Last Month</option>
              <option value="last3Months">Last 3 Months</option>
              <option value="last6Months">Last 6 Months</option>
            </select>
          </div>
        </div>

        {/* Student List */}
        <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  #
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Student
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Username
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date Joined
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Time Joined
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Total Courses
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Courses
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Teachers
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredStudents?.map((student, index) => (
                <tr key={student.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                        {student.avatar ? (
                          <img
                            src={student.avatar}
                            alt={student.name}
                            className="h-full w-full rounded-full object-cover"
                          />
                        ) : (
                          <span className="text-gray-600 font-medium">
                            {student.name.charAt(0)}
                          </span>
                        )}
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {student.name}
                        </div>
                        <div className="text-sm text-gray-500">
                          {student.email}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {student.username}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {student.dateJoined}
                  </td>

                  {/* Time Joined */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {student.timeJoined}
                  </td>

                  {/* Total Courses */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-700 font-semibold">
                    {student.totalCourses || student.courses.length}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex flex-wrap gap-1">
                      {student.courses.map((course, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        >
                          {course}
                        </span>
                      ))}
                    </div>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex flex-wrap gap-1">
                      {student.teachers.map((teacher, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        >
                          {teacher}
                        </span>
                      ))}
                    </div>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                      <button
                        className="p-1 hover:bg-gray-100 rounded"
                        onClick={() => {
                          setEditingStudent(student);
                          setIsModalOpen(true);
                        }}
                      >
                        <Pencil className="h-4 w-4 text-gray-500" />
                      </button>
                      <button
                        className="p-1 hover:bg-gray-100 rounded"
                        onClick={() => handleDeleteStudent(student)}
                      >
                        <Trash2 className="h-4 w-4 text-red-500" />
                      </button>
                      <button className="p-1 hover:bg-gray-100 rounded">
                        <MoreVertical className="h-4 w-4 text-gray-500" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add/Edit Student Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">
              {editingStudent ? 'Edit Student' : 'Add New Student'}
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Full Name
                </label>
                <input
                  name="name"
                  type="text"
                  defaultValue={editingStudent?.name}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter full name"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  defaultValue={editingStudent?.email}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter email address"
                  required
                />
              </div>

              {/* <div>
                <label className="block text-sm font-medium text-gray-700">
                  Grade/Year
                </label>
                <select 
                  name="grade"
                  defaultValue={editingStudent?.grade}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  required
                >
                  <option value="">Select grade</option>
                  <option>Grade 9</option>
                  <option>Grade 10</option>
                  <option>Grade 11</option>
                  <option>Grade 12</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Courses
                </label>
                <div className="mt-2 space-y-2">
                  {['Mathematics', 'Physics', 'Chemistry', 'Biology'].map((course) => (
                    <label key={course} className="inline-flex items-center mr-4">
                      <input
                        type="checkbox"
                        name="courses"
                        value={course}
                        defaultChecked={editingStudent?.courses.includes(course)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="ml-2 text-sm text-gray-700">{course}</span>
                    </label>
                  ))}
                </div>
              </div> */}

              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setIsModalOpen(false);
                    setEditingStudent(null);
                  }}
                  className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  {editingStudent ? 'Update' : 'Add'} Student
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-full max-w-sm">
            <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete {studentToDelete.name}? This
              action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setStudentToDelete(null);
                }}
                className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
